import {
    CONFIRM_PAYMENT_INTENT_START,
    CONFIRM_PAYMENT_INTENT_SUCCESS,
    CONFIRM_PAYMENT_INTENT_ERROR
} from '../../constants';
import { setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { confirmPaymentIntent as mutation, getPaymentMethod as query } from '../../lib/graphql';
import { getCurrencySymbol } from '../../helpers/currencyConvertion';
import history from '../../history';

export function confirmPaymentIntent({ paymentIntentId, cardLastFour, amount, currency, orderId ,bookingId}) {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: CONFIRM_PAYMENT_INTENT_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    paymentIntentId,
                    cardLastFour,
                    amount: parseFloat(amount),
                    currency
                },
                refetchQueries: [{ query }]
            });
            let symbol = getCurrencySymbol(currency), walletAmount = amount + symbol;

            if (data?.confirmPaymentIntent?.result?.requireAdditionalAction) {
                let errorMessage = data?.confirmPaymentIntent?.errorMessage
                showToaster({ messageId: 'catchMessage', requestContent: errorMessage, toasterType: 'error' });
                setLoaderComplete('addCardDetails');
                dispatch({
                    type: CONFIRM_PAYMENT_INTENT_ERROR,
                });
            } else {
                dispatch(setLoaderComplete('addCardDetails'))
                orderId
                    ? history.push(`/order/${orderId}`)
                    : (bookingId
                        ? history.push(`/tracking/${bookingId}`)
                        : history.push('/payment-method'));
                let requestContent = walletAmount
                await showToaster({ messageId: 'walletAmountAdded', requestContent, toasterType: 'success' });
                dispatch({
                    type: CONFIRM_PAYMENT_INTENT_SUCCESS,
                });
            }
        } catch (error) {
            dispatch({
                type: CONFIRM_PAYMENT_INTENT_ERROR,
            });
            dispatch(setLoaderComplete('addCardDetails'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}